"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRepeatActions = createRepeatActions;
function createRepeatActions(originalAction, defaultRequest) {
    let lastRequest = null;
    const action = (request) => {
        lastRequest = request;
        return originalAction(request);
    };
    const repeatAction = () => originalAction(lastRequest !== null && lastRequest !== void 0 ? lastRequest : defaultRequest);
    return {
        action,
        repeatAction
    };
}
//# sourceMappingURL=createRepeatAction.js.map